import React, { useState } from "react";
import BackButton from "../components/BackButton";
import { Helmet } from "react-helmet";

const CalorieCalculator = () => {
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("male");
  const [height, setHeight] = useState(""); // cm
  const [weight, setWeight] = useState("");  // kg
  const [activity, setActivity] = useState("sedentary");

  const activityLevels = {
    sedentary: 1.2,
    light: 1.375,
    moderate: 1.55,
    active: 1.725,
    veryActive: 1.9,
  };

  const isValidInput = () => {
    return (
      age > 0 &&
      height > 0 &&
      weight > 0 &&
      age < 120 &&
      height < 300 &&
      weight < 500
    );
  };

  const calculateBMR = () => {
    if (!isValidInput()) return 0;
    if (gender === "male") {
      return 10 * Number(weight) + 6.25 * Number(height) - 5 * Number(age) + 5;
    } else {
      return 10 * Number(weight) + 6.25 * Number(height) - 5 * Number(age) - 161;
    }
  };

  const bmr = calculateBMR();
  const tdee = bmr * (activityLevels[activity] || 1);

  const caloriesMaintain = isValidInput() ? Math.round(tdee) : "-";
  const caloriesFatLoss = isValidInput() ? Math.round(tdee * 0.8) : "-";
  const caloriesMuscleGain = isValidInput() ? Math.round(tdee * 1.15) : "-";
  const caloriesWeightGain = isValidInput() ? Math.round(tdee * 1.25) : "-";

  const proteinMaintain = isValidInput() ? Math.round(weight * 1.0) : "-";
  const proteinFatLoss = isValidInput() ? Math.round(weight * 1.8) : "-";
  const proteinMuscleGain = isValidInput() ? Math.round(weight * 2.0) : "-";
  const proteinWeightGain = isValidInput() ? Math.round(weight * 1.8) : "-";

  return (
    <>


        <Helmet>
         <title>Advanced Calorie Calculator - Weight Loss, Muscle Gain & More</title>
            <meta
                name="description"
                content="Free advanced calorie calculator to estimate your daily calorie needs based on your goal: lose weight, gain muscle, or maintain. Tailored results using BMR & activity level."
            />
            <meta
                name="keywords"
                content="calorie calculator, advanced calorie tool, weight loss calculator, muscle gain calories, maintenance calories, fitness calorie tool"
            />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://freelity.com/calorie-calculator" />
        </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Calorie & Protein Calculator</h2>

          <form>
            <div className="mb-3">
              <label htmlFor="age" className="form-label">Age</label>
              <input
                type="number"
                className="form-control"
                id="age"
                min={10}
                max={120}
                placeholder="Enter age"
                value={age}
                onChange={(e) => setAge(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="gender" className="form-label">Gender</label>
              <select
                id="gender"
                className="form-select"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
              >
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>

            <div className="mb-3">
              <label htmlFor="height" className="form-label">Height (cm)</label>
              <input
                type="number"
                className="form-control"
                id="height"
                min={100}
                max={300}
                placeholder="Enter height"
                value={height}
                onChange={(e) => setHeight(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="weight" className="form-label">Weight (kg)</label>
              <input
                type="number"
                className="form-control"
                id="weight"
                min={30}
                max={500}
                placeholder="Enter weight"
                value={weight}
                onChange={(e) => setWeight(e.target.value)}
              />
            </div>

            <div className="mb-4">
              <label htmlFor="activity" className="form-label">Activity Level</label>
              <select
                id="activity"
                className="form-select"
                value={activity}
                onChange={(e) => setActivity(e.target.value)}
              >
                <option value="sedentary">No Exercise (Sedentary)</option>
                <option value="light">Light Exercise</option>
                <option value="moderate">Moderate Exercise</option>
                <option value="active">Active</option>
                <option value="veryActive">Very Active</option>
              </select>
            </div>
          </form>

          <h4 className="mb-3">Results</h4>
          <ul className="list-group">
            <li className="list-group-item">
              Maintain Weight:
              <span className="badge bg-primary rounded-pill">
                <b>{caloriesMaintain} kcal</b> / Protein: <b>{proteinMaintain} g</b>
              </span>
            </li>
            <li className="list-group-item">
              Fat Loss (20% deficit):
              <span className="badge bg-danger rounded-pill">
                <b>{caloriesFatLoss} kcal</b> / Protein: <b>{proteinFatLoss} g</b>
              </span>
            </li>
            <li className="list-group-item">
              Muscle Gain (15% surplus):
              <span className="badge bg-success rounded-pill">
                <b>{caloriesMuscleGain} kcal</b> / Protein: <b>{proteinMuscleGain} g</b>
              </span>
            </li>
            <li className="list-group-item">
              Weight Gain (25% surplus):
              <span className="badge bg-warning text-dark rounded-pill">
                <b>{caloriesWeightGain} kcal</b> / Protein: <b>{proteinWeightGain} g</b>
              </span>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default CalorieCalculator;
